import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { VisitorPayload, VisitorRecord } from "@project/types/visitor";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/visitors`;
const SILENT: RequestConfig = { showNotification: false };

class VisitorService {
  listVisitorsPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<VisitorRecord>> => {
    return fetchListPage<VisitorRecord>(`${BASE}/`, query);
  };

  getVisitor = async (id: number): Promise<VisitorRecord | undefined> => {
    const data = await get<ApiItemResponse<VisitorRecord> | VisitorRecord>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  createVisitor = async (
    payload: VisitorPayload
  ): Promise<VisitorRecord | undefined> => {
    const data = await post<
      ApiItemResponse<VisitorRecord> | VisitorRecord,
      VisitorPayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  updateVisitor = async (
    id: number,
    payload: Partial<VisitorPayload>
  ): Promise<VisitorRecord | undefined> => {
    const data = await patch<
      ApiItemResponse<VisitorRecord> | VisitorRecord,
      Partial<VisitorPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  deleteVisitor = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const visitorService = new VisitorService();
